export default "__VITE_ASSET__r4VcnJF6__"